export enum CONTACT_TYPE {
  TELF = 'TELF',
  SMS = 'SMS_',
  FAX = 'FAX',
  EMAIL = 'EMAI',
  ADDRESS = 'DPOS',
}

export enum CONTACT_TYPE_TCOL {
  TELF = '1',
  SMS = '2',
  FAX = '3',
  EMAIL = '4',
  ADDRESS = '5',
}

export type MediumContact = {
  contactType: CONTACT_TYPE;
  contactTypeTCOL: CONTACT_TYPE_TCOL;
  value: string;
  favourite: boolean;
  advertisingUse: boolean;
  address: {
    id: string | '' | null;
    locationFullAddress: string | '' | null;
  };
};
